import React from "react";

import "./phoneBook.scss";

interface PhoneBookInterface {
  directory: any;
}

const PhoneBook = (props: PhoneBookInterface) => {
  const { directory } = props;

  const phonenumber = (option) => {
    if (
      directory.redireccionBoton &&
      directory.redireccionBoton.includes("ext")
    ) {
      return directory.redireccionBoton.split("ext")[option];
    }
    if (option === 0) {
      return directory.redireccionBoton;
    }
  };

  return (
    <div className="a-phonebook">
      <h2 className="a-phonebook__title">{directory.tituloPrincipal}</h2>
      <p className="a-phonebook__addres">{directory.textoBoton}</p>
      <p className="a-phonebook__phonenumber">
        {phonenumber(0) && <i className="icon icon-phone show-on-mobile" />}
        {phonenumber(0)} <span>{phonenumber(1) && `ext${phonenumber(1)}`}</span>
      </p>
    </div>
  );
};

export default PhoneBook;
